<template>
  <article class="card p-4">
    <header class="p-2">
      <slot name="header"></slot>
    </header>
    <section class="p-2 text-base">
      <slot></slot>
    </section>
    <footer class="p-2">
      <slot name="footer"></slot>
    </footer>
  </article>
</template>
